import { FormsLangToAdConsentLangMap } from 'forms-utils-lib/language/LanguageConstants';
import { getFormsLangToLangMap } from 'forms-utils-lib/language/getFormsLangToLangMap';
export const formsLangToAdConsentLang = getFormsLangToLangMap(FormsLangToAdConsentLangMap);